var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCannedResponses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2252 10L14.2252 11.3333C14.2252 13.6667 12.932 14.6667 10.9922 14.6667H4.52621C2.58641 14.6667 1.29321 13.6667 1.29321 11.3333V6.66668C1.29321 4.33334 2.58641 3.33334 4.52621 3.33334H6.60752",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52612 7L6.54998 8.66667C7.21598 9.21333 8.30873 9.21333 8.97472 8.66667",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7291 2.09375L13.9809 2.62278C14.1068 2.88266 14.4215 3.12399 14.7003 3.17967L15.042 3.23536C16.0673 3.41171 16.3101 4.19135 15.5726 4.96171L15.2579 5.28655C15.051 5.5093 14.9341 5.93625 14.9971 6.23326L15.042 6.42818C15.3208 7.70901 14.6643 8.20092 13.5852 7.53266L13.3513 7.39344C13.0726 7.22637 12.6229 7.22637 12.3441 7.39344L12.1103 7.53266C11.0221 8.2102 10.3656 7.70901 10.6534 6.42818L10.6984 6.23326C10.7613 5.93625 10.6444 5.5093 10.4376 5.28655L10.1228 4.96171C9.38538 4.19135 9.62819 3.41171 10.6534 3.23536L10.9951 3.17967C11.2649 3.13327 11.5887 2.88266 11.7146 2.62278L11.9664 2.09375C12.452 1.08207 13.2434 1.08207 13.7291 2.09375Z",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannedResponses);
export default __webpack_public_path__ + "static/media/cannedResponses.beecef4788eb9c3ce74511fd803031c4.svg";
export { ForwardRef as ReactComponent };